import React from "react";
import { Container } from "reactstrap";
import { RouteComponentProps } from "react-router";
import { FeedbackCategory, FeedbackSortOption } from "../../../Feedback/Constants/feedbackEnums";
import FeedbackListContainer from "../../../Feedback/Components/Common/FeedbackList/FeedbackListContainer";

type TParams = {
  shortname: string;
};

const FEATURE_REQUEST = [FeedbackCategory.FeatureRequest];

const CompanyProfileFeatureRequestsContainer: React.FC<RouteComponentProps<TParams>> = props => (
  <Container fluid>
    <FeedbackListContainer
      listId={`APP_COMPANY_PROFILE_ALL_FEATURE_REQUESTS_LIST${props.match.params.shortname}`}
      sort={FeedbackSortOption.DateCreated}
      isAscending={false}
      reorderable
      shortname={props.match.params.shortname}
      fullscreen
      enableDownload
      selectedCategories={FEATURE_REQUEST}
    />
  </Container>
);

export default CompanyProfileFeatureRequestsContainer;
